'use client';

import React, { useEffect, useState } from 'react';
import type { ArticleNode } from 'data-layer';
import { DownloadSteps } from './partials';
import { DownloadStepsSkeleton } from './DownloadStepsSkeleton';
import { filterDownloadSteps } from './utils';
import { useDeviceInfo } from 'hooks';
import type { DownloadStepsWithSkeletonProps } from './types';

/**
 * DownloadStepsWithSkeleton Component
 *
 * Client-side filtering of download steps based on OS and browser.
 * Shows a skeleton while the user agent is being detected and download steps are being filtered.
 */
export function DownloadStepsWithSkeleton({ articles, device }: DownloadStepsWithSkeletonProps) {
  const { operatingSystem, browser } = useDeviceInfo();
  const [filteredArticle, setFilteredArticle] = useState<ArticleNode | null>(null);
  const [isDetecting, setIsDetecting] = useState(true);

  useEffect(() => {
    setIsDetecting(true);

    if (operatingSystem && browser) {
      setFilteredArticle(filterDownloadSteps({ articles, operatingSystem, browser }));
      setIsDetecting(false);
    } else {
      setFilteredArticle(null);
      setIsDetecting(false);
    }
  }, [articles, operatingSystem, browser]);

  if (isDetecting) {
    return <DownloadStepsSkeleton />;
  }

  return filteredArticle ? <DownloadSteps article={filteredArticle} device={device} /> : null;
}
